import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type {
    MigrationStatusResponse,
    PlanMigrationSchema,
} from '../types/plan-migration';

const initialState: PlanMigrationSchema = {
    isOpen: false,
    isChecked: false,
    migrationData: null,
};

export const planMigrationSlice = createSlice({
    name: 'planMigration',
    initialState,
    reducers: {
        showPopup: (state, action: PayloadAction<MigrationStatusResponse>) => {
            state.isOpen = true;
            state.isChecked = true;
            state.migrationData = action.payload;
        },
        hidePopup: (state) => {
            state.isOpen = false;
        },
        setChecked: (state) => {
            state.isChecked = true;
        },
    },
});

export const { actions: planMigrationActions, reducer: planMigrationReducer } =
    planMigrationSlice;
